export enum SidebarContentTypes {
  IN_CONSOLE_TRAINING = "in-console-training",
  IN_CONSOLE_MESSAGES = "in-console-messages",
}
